import { tlds } from "../constants";

const attemptDecode = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const safeRecursiveDecode = (input: string, maxDepth = 3): string => {
  let result = input;
  for (let i = 0; i < maxDepth; i++) {
    const decoded = attemptDecode(result);
    if (decoded === result) break;
    result = decoded;
  }
  return result;
};

const stripHtmlTags = (input: string): string => {
  return input.replace(/<[^>]*>/g, "");
};

// Regex parts
const scheme = `(?:[a-z]+:\\/\\/)?`;
const localhost = `localhost`;
const hostnameSegment = `[a-z0-9](?:[a-z0-9-]*[a-z0-9])?`;
const domain = `(?:${hostnameSegment}\\.)+`;
const validTlds = tlds.join("|");
const port = `(?::\\d+)?`;
const path = `(?:\\/[^\\s"'<>]*)?`;

const hostWithTld = `(?:${localhost}|${domain}(?:${validTlds}))\\b`;

const fullUrlRegex = new RegExp(`\\b(${scheme}${hostWithTld}${port}${path})`, "gi");

const dangerousSchemeRegex = new RegExp(`\\b(?:javascript|data|mailto|vbscript):[^\\s"'<>]*`, "gi");

export const isStringContainingURL = (text: string): string[] | null => {
  if (typeof text !== "string") return null;

  const cleanedText = stripHtmlTags(text);
  const decodedText = safeRecursiveDecode(cleanedText);

  const matches = [...(decodedText.match(fullUrlRegex) || []), ...(decodedText.match(dangerousSchemeRegex) || [])];

  return matches.length > 0 ? matches : null;
};
